import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { SuccessSwal, warningSwal } from "../../../Util/Toast";
import styles from "./index.module.css";
import { useForm } from "react-hook-form";
import { FaRegUser } from "react-icons/fa";
import Nav from "../Nav/Nav";
import Footer from "../Footer/Footer";
import useStore from "../../../Store";
import { getUserblogsbyslug, blogsreplay } from "../../../Services/APIrequests";
import trade1 from "../../../Assets/trdaereports1.png";
import trade2 from "../../../Assets/trdaereports2.png";
import Blog1 from "./Blog1";
import parse from "html-react-parser";
import { FaShareAlt } from "react-icons/fa";
import copy from "copy-to-clipboard";
import defaultIMG from "../../../Assets/defaultimg.png";
import { RotatingLines } from "react-loader-spinner";
import blog from "./blog.module.css";
import Swal from "sweetalert2";
import { newletters } from "../../../Services/APIrequests"; // Adjust the path if needed

export const SingleBlog = () => {
    const { blogId } = useParams();
    const [formData, setFormData] = useState({ name: "", email: "" });
    const [message, setMessage] = useState("");
    const [blogDetails, setBlogDetails] = useState(null);
    const [loading, setLoading] = useState(true);
    const [showNewsletter, setShowNewsletter] = useState(false);
    const [lastScrollY, setLastScrollY] = useState(0);
    const [subscribed, setSubscribed] = useState(false);
    const [dismissed, setDismissed] = useState(false);

    const direction = useStore((state) => state.direction);

    const handleShareClick = () => {
        const currentUrl = window.location.href;
        const isCopied = copy(currentUrl);
        if (isCopied) {
            alert("Link copied to clipboard!");
        } else {
            alert("Failed to copy the link, please try again.");
        }
    };

    useEffect(() => {
        const fetchBlogDetails = async () => {
            setLoading(true);
            try {
                const response = await getUserblogsbyslug(blogId);
                if (response && response.data) {
                    setBlogDetails(response.data.blog);
                    // SuccessSwal("Successfully fetched blog details", response.data.blog);
                } else {
                    warningSwal("No blog found with this ID.");
                }
            } catch (error) {
                warningSwal(
                    error.response
                        ? error.response.data.message
                        : "Something went wrong, try refreshing the page",
                    "warning"
                );
            } finally {
                setLoading(false);
            }
        };

        if (blogId) {
            fetchBlogDetails();
        }
    }, [blogId]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.name || !formData.email) {
            Swal.fire({
                icon: "warning",
                title: "Missing Fields",
                text: "Please fill all fields.",
            });
            return;
        }

        try {
            setLoading(true);
            const response = await newletters(formData);

            if (response.data.Status === 1) {
                Swal.fire({
                    icon: "success",
                    title: "Subscribed!",
                    text: "Subscribed successfully!",
                });
                setFormData({ name: "", email: "" });
                setSubscribed(true); // Mark as subscribed
                setShowNewsletter(false); // Close popup
            } else {
                Swal.fire({
                    icon: "error",
                    title: "Subscription Failed",
                    text: "Please try again later.",
                });
            }
        } catch (error) {
            Swal.fire({
                icon: "error",
                title: "Oops!",
                text: "An error occurred. Please try again.",
            });
        } finally {
            setLoading(false);
        }
    };

    const handleChange = (e) => {
        setFormData((prev) => ({
            ...prev,
            [e.target.name]: e.target.value,
        }));
    };

    // Scroll detection
    useEffect(() => {
        const handleScroll = () => {
            const currentScrollY = window.scrollY;

            if (
                !subscribed &&
                !dismissed &&
                currentScrollY < lastScrollY &&
                currentScrollY > 300
            ) {
                setShowNewsletter(true);
            }

            setLastScrollY(currentScrollY);
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, [lastScrollY, subscribed, dismissed]);

    // Close popup
    const closeNewsletter = () => {
        setShowNewsletter(false);
        setDismissed(true);
    };

    if (loading) {
        return (
            <p>
                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "100vh",
                    }}>
                    <RotatingLines
                        height="80"
                        width="80"
                        color="#4fa94d"
                        ariaLabel="circles-loading"
                        visible={true}
                    />
                </div>
            </p>
        );
    }

    if (!blogDetails) {
        return <p>Blog not found.</p>;
    }

    return (
        <div>
            <div style={{ direction }}>
                <Nav />
                <Blog1 />

                {/* Newsletter Popup */}
                {showNewsletter && (
                    <div className={styles.newsletterOverlay}>
                        <div className={styles.newsletterPopup}>
                            <div className={styles.newsletterHeader}>
                                <h3 className={styles.newsletterTitle}>
                                    Subscribe to our Newsletter
                                </h3>
                                <button
                                    type="button"
                                    className={styles.closeBtn}
                                    onClick={closeNewsletter}
                                    aria-label="Close">
                                    &times;
                                </button>
                            </div>

                            <form
                                className={styles.newsletter_form}
                                onSubmit={handleSubmit}>
                                <input
                                    type="text"
                                    name="name"
                                    placeholder="First name"
                                    className={styles.newsletter_input}
                                    value={formData.name}
                                    onChange={handleChange}
                                />
                                <input
                                    type="email"
                                    name="email"
                                    placeholder="Email address"
                                    className={styles.newsletter_input}
                                    value={formData.email}
                                    onChange={handleChange}
                                />
                                <button
                                    type="submit"
                                    className={styles.newsletter_button}
                                    disabled={loading}>
                                    {loading
                                        ? "Submitting..."
                                        : "Subscribe Now"}
                                </button>
                            </form>
                        </div>
                    </div>
                )}

                <div className={styles.Single_container}>
                    <div className={styles["blog_contents"]}>
                        <div className={styles.contnet1}>
                            <h2 className={styles.headtext}>
                                {blogDetails.title}
                            </h2>
                            <div className={styles.conentimg_container}>
                                <div className={styles.blogimg_container}>
                                    {blogDetails?.fileURL &&
                                    blogDetails.fileURL.endsWith(".mp4") ? (
                                        <video
                                            controls
                                            className={styles.img}
                                            onError={(e) => {
                                                e.target.onerror = null;
                                                e.target.style.display = "none"; // hide video on error
                                            }}>
                                            <source
                                                src={blogDetails.fileURL}
                                                type="video/mp4"
                                            />
                                            Your browser does not support the
                                            video tag.
                                        </video>
                                    ) : (
                                        <img
                                            src={
                                                blogDetails?.image_url ||
                                                defaultIMG
                                            }
                                            alt="Blog Image"
                                            onError={({ currentTarget }) => {
                                                currentTarget.onerror = null;
                                                currentTarget.src = defaultIMG;
                                            }}
                                            className={styles.img}
                                        />
                                    )}
                                </div>
                                <div className={styles.blogpara_container}>
                                    {/* <div className={styles.para}>{parse(blogDetails.shortDescription)}</div> */}

                                    <div className={styles.para}>
                                        {typeof blogDetails.shortDescription ===
                                        "string" ? (
                                            parse(blogDetails.shortDescription)
                                        ) : (
                                            <p>No description available.</p>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className={styles.comments_cont}>
                                <div>
                                    <p className={styles.commentbox}>
                                        <p className={styles.icon}>
                                            <FaRegUser size={20} />
                                        </p>
                                        <p>By-Admin</p>
                                    </p>
                                </div>

                                {blogDetails.youtubeUrl && (
                                    <div className={styles.youtube}>
                                        <p
                                            style={{
                                                marginTop: "10px",
                                                fontSize: "18px",
                                                color: "#111",
                                            }}>
                                            For more information, visit:{" "}
                                            <a
                                                href={blogDetails.youtubeUrl}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                style={{
                                                    color: "#0073e6",
                                                    fontWeight: 500,
                                                }}>
                                                YouTube Link
                                            </a>
                                        </p>
                                    </div>
                                )}
                                <div
                                    className={styles.blog_share}
                                    onClick={handleShareClick}>
                                    <FaShareAlt />
                                    Share Blog
                                </div>
                            </div>
                        </div>
                        <div className={styles.content2}>
                            <div className={styles.para}>
                                {typeof blogDetails.description === "string" ? (
                                    parse(blogDetails.description)
                                ) : (
                                    <p>No additional content available.</p>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className={styles.commentsform}>
                        <h3 className={styles.headtext}>Related Images</h3>
                        {Array.isArray(blogDetails?.bolgImages) &&
                        blogDetails.bolgImages.length > 0 ? (
                            <div className={styles.imageList}>
                                {blogDetails.bolgImages.map((imgObj, index) => (
                                    <div
                                        key={index}
                                        className={styles.imageCard}>
                                        <img
                                            src={imgObj.image}
                                            alt={
                                                imgObj.name ||
                                                `Image ${index + 1}`
                                            }
                                            className={styles.serviceImagecom}
                                        />
                                        {imgObj.name && (
                                            <h4 className={styles.imageName}>
                                                {imgObj.name}
                                            </h4>
                                        )}
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <p className={styles.noImages}>
                                No blog images available.
                            </p>
                        )}
                    </div>
                </div>

                <Footer />
            </div>
        </div>
    );
};
